import React from "react";
import PropTypes from "prop-types";

import { useTrans } from "../../../../hooks";
import ContestFormField from "../ContestFormField";
import { MAP_TARGET_AUDIENCES } from "../constants";

const TargetAudienceField = ({ form, disableForm, onFormChange }) => {
  const { trans } = useTrans();

  const title = trans("Target Audience");

  const subtitle = (
    <div className="subtitle">
      {trans(
        "Please indicate if your story is geared towards young adults (13-18 year olds), new adults (18-25 year olds), or adults (those 25 years of age or older)."
      )}
    </div>
  );

  return (
    <ContestFormField title={title} subtitle={subtitle}>
      <>
        <select
          id="target-audience-select"
          value={form.targetAudience}
          name="targetAudience"
          disabled={disableForm}
          className={"form-element"}
          onChange={onFormChange}
          aria-label={trans("Select an option")}
        >
          <option value="" disabled>
            {trans("Select an option")}
          </option>
          {MAP_TARGET_AUDIENCES(trans).map(length => (
            <option key={length.key} value={length.key}>
              {length.value}
            </option>
          ))}
        </select>
      </>
    </ContestFormField>
  );
};

TargetAudienceField.propTypes = {
  form: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  onFormChange: PropTypes.func.isRequired
};

export default TargetAudienceField;
